import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  CreateEmailChannelPolicyRequest,
  EmailChannelPolicy,
  UpdateEmailChannelPolicyRequest,
} from '../models/email-channel-policy.model';

@Injectable({ providedIn: 'root' })
export class EmailChannelPolicyApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/admin/email-channel-policies`;

  /** Lista todas las políticas (response es un array plano, no paginado). */
  list(): Observable<EmailChannelPolicy[]> {
    return this.http.get<EmailChannelPolicy[]>(this.base);
  }

  create(req: CreateEmailChannelPolicyRequest): Observable<EmailChannelPolicy> {
    return this.http.post<EmailChannelPolicy>(this.base, req);
  }

  update(id: number, req: UpdateEmailChannelPolicyRequest): Observable<EmailChannelPolicy> {
    return this.http.put<EmailChannelPolicy>(`${this.base}/${id}`, req);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }
}
